/*eslint-disable*/
export default [
    {
        path: '/olympiads',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "olympiad" */'../../layouts/olympiads/Layout.vue'),
        children: [
            {
                path: '',
                name: 'olympiads:index',
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "olympiad" */'../../components/olympiad/List.vue'),
                meta: {
                    title: 'router.router_olympiads',
                    emptyContent: true,
                    prev: {
                        name: 'dashboard'
                    }
                }
            },
            {
                path: ':id',
                name: 'olympiads:show',
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "olympiad" */'../../components/olympiad/ShowPage.vue'),
                meta: {
                    title: 'router.router_olympiad',
                    emptyContent: true,
                    olympiadTitle: 'olympiad'
                },
                props: true
            },
            {
                path: ':id/start',
                name: 'olympiads:start',
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "olympiad" */'../../components/olympiad/StartPage.vue'),
                meta: {
                    title: 'router.router_olympiad',
                    emptyContent: true
                },
                props: true
            },
            {
                path: ':id/register',
                name: 'olympiads:register',
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "olympiad" */'../../components/olympiad/RegisterPage.vue'),
                meta: {
                    title: 'router.router_olympiadRegistration',
                    emptyContent: true,
                    olympiadTitle: 'olympiad'
                },
                props: true
            },
            {
                path: 'stage/:id/results',
                name: 'olympiads:stage-results',
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "olympiad" */'../../components/olympiad/ProcessStage.vue'),
                meta: {
                    title: 'router.router_stageResults',
                    emptyContent: true,
                    olympiadTitle: 'olympiad'
                },
                props: true
            },
            {
                path: ':id/results',
                name: 'olympiads:results',
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "olympiad" */'../../components/olympiad/ResultsPage.vue'),
                meta: {
                    title: 'router.router_olympiadResults',
                    emptyContent: true,
                    olympiadTitle: 'olympiad'
                },
                props: true
            },
            {
                path: ':id/students-list',
                name: 'olympiads:students-list',
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "olympiad" */'../../components/olympiad/studentsList/Main.vue'),
                meta: {
                    title: 'router.router_olympiadStudentsList',
                    emptyContent: true,
                    olympiadTitle: 'olympiad'
                },
                props: true
            },
            {
                path: ':id/payment/success',
                name: 'olympiads-payment:success',
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "olympiad" */'../../components/billing/payment/Result.vue'),
                meta: {
                    title: 'router.router_successfulOlympiadPayment',
                    emptyContent: true
                },
                props: true
            },
            {
                path: ':id/payment/failure',
                name: 'olympiads-payment:failure',
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "olympiad" */'../../components/billing/payment/Result.vue'),
                meta: {
                    title: 'router.router_failedOlympiadPayment',
                    emptyContent: true
                },
                props: true
            }
        ],
    },
    {
        path: 'trainer/olympiads/create',
        name: 'olympiads:create',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "olympiad" */'../../components/olympiad/Create.vue'),
        meta: {
            title: 'router.router_addOlympiad',
            prev: {
                name: 'olympiads:index'
            }
        },
        props: true
    },
    {
        path: 'trainer/olympiads/:olympiadId/edit',
        name: 'olympiads:edit',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "olympiad" */'../../components/olympiad/Edit.vue'),
        meta: {
            title: 'router.router_editOlympiad',
            prev: {
                name: 'olympiads:index'
            }
        },
        props: true
    },
    {
        path: 'trainer/olympiads/:olympiadId?/level/:index/create',
        name: 'olympiad-level:create',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "olympiad" */'../../components/olympiad/EditLevel.vue'),
        meta: {
            title: 'router.router_editLevel',
            prev ($route) {
                return { name: $route.params.olympiadId ? 'olympiads:edit' : 'olympiads:create' }
            }
        },
        props ($route) {
            return {
                index: $route.params.index,
                olympiadId: $route.params.olympiadId
            }
        }
    },
    {
        path: 'trainer/olympiads/:olympiadId?/level/:index/stage/:stageId/game/:id/edit/:generatorSettings?/:generatorGameIndex?',
        name: 'stage-game:edit',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "olympiad" */'../../components/olympiad/GameEdit.vue'),
        meta: {
            title: 'router.router_editOlympiadGame',
            prev: {
                name: 'olympiad-level:create'
            }
        },
        props: true
    }
];
